// services/propertyStatus.service.ts
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IPropertyStatus } from "../propertyStatusModal";

export const getAllPropertyStatuses = createAsyncThunk(
  "PropertyStatus/FindAllPropertyStatus",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PropertyStatus/FindAllPropertyStatus`,
        {
          Title: "",
        },
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Property Statuses:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createPropertyStatus = createAsyncThunk(
  "PropertyStatus/InsertPropertyStatus",
  async (propertyStatusData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PropertyStatus/InsertPropertyStatus`,
        propertyStatusData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Property Status:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updatePropertyStatus = createAsyncThunk(
  "PropertyStatus/UpdatePropertyStatus",
  async (propertyStatusData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PropertyStatus/UpdatePropertyStatus`,
        propertyStatusData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Property Status:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deletePropertyStatus = createAsyncThunk(
  "PropertyStatus/DeletePropertyStatus",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PropertyStatus/DeletePropertyStatus`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Property Status:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getPropertyStatusByID = createAsyncThunk(
  "PropertyStatus/FindByIDPropertyStatus",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PropertyStatus/FindByIDPropertyStatus`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result.Title,
        IsActive: result.IsActive ? 1 : 2,
      } as IPropertyStatus;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Property Status:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActivePropertyStatuses = createAsyncThunk(
  "PropertyStatus/FindAllActivePropertyStatus",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/PropertyStatus/FindAllActivePropertyStatus`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Active Property Statuses:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const activeInactivePropertyStatus = createAsyncThunk(
  "PropertyStatus/ActiveInActivePropertyStatus",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PropertyStatus/ActiveInActivePropertyStatus`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Property Status:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
